import apiClient from '@/api/apiClient';

export interface WorkflowAccessCheck {
  hasActiveWorkflow: boolean;
  canEditInitialStage: boolean;
  requiredRoleNames: string[];
}

export default {
  getConfig(workflowType: string = 'investigation'): Promise<any> {
    return apiClient.get(`/workflow/config/${workflowType}`);
  },
  getFullConfig(workflowId: string): Promise<any> {
    return apiClient.get(`/workflow/blueprints/${workflowId}/full-config`);
  },
  checkAccess(workflowType: string): Promise<WorkflowAccessCheck> {
    return apiClient.get(`/workflow/check-access/${workflowType}`);
  },
};
